// extracted by mini-css-extract-plugin
module.exports = {"empty-view":"empty-view___1D7-3"};